<template>
  <router-link :to="to" tag="button" class="button">{{ name }}</router-link>
</template>

<script>
module.exports = {
  props: ["name", "to"],
};
</script>
